module.exports = __webpack_public_path__ + "img/1f953.60b4a11.svg";